import styled from "styled-components";
import { theme } from "../../styles/styles";

interface ButtonProps {
  variant?: "primary" | "secondary" | "outline";
  color?: string;
  type?: "button" | "submit" | "reset";
}

export const StyledButton = styled("button")<ButtonProps>`
  background: ${(p) => {
    if (p.variant === "outline") return "transparent";
    if (p.variant === "secondary") return theme.colors.background;
    return p.color || theme.colors.accent;
  }};
  color: ${(p) => {
    if (p.variant === "outline") return p.color || theme.colors.accent;
    if (p.variant === "secondary") return theme.colors.primary;
    return theme.colors.background;
  }};
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes.small};
  font-weight: 600;
  width: auto;
  border: ${(p) => {
    if (p.variant === "outline") return `1.5px solid ${p.color || theme.colors.accent}`;
    return "1px solid transparent";
  }};
  border-radius: 6px;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
  margin: 0;
  transition: all 0.2s ease;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  letter-spacing: 0.025em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${(p) => {
      if (p.variant === "outline") return p.color || theme.colors.accent;
      if (p.variant === "secondary") return theme.colors.lightGray;
      return "#0052CC";
    }};
    color: ${(p) => {
      if (p.variant === "outline") return theme.colors.background;
      return theme.colors.background;
    }};
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(47, 128, 237, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }
`;
